// Loading.js
import React, { useEffect } from "react";
import "./Loading.css";

const Loading = () => {
  useEffect(() => {
    // Dynamically update the favicon during loading
    const favicon = document.createElement("link");
    favicon.rel = "icon";
    favicon.href = "/favicon.ico"; // Path to your favicon
    favicon.id = "loading-favicon";
    document.head.appendChild(favicon);

    return () => {
      // Clean up by removing the loading favicon when the component unmounts
      const loadingFavicon = document.getElementById("loading-favicon");
      if (loadingFavicon) {
        document.head.removeChild(loadingFavicon);
      }
    };
  }, []);

  return (
    <div className="loading-overlay">
      <div className="favicon-spinner"></div>
    </div>
  );
};

export default Loading;